export default __webpack_public_path__ + "static/media/audio_54_galleta_mordida.9b0c36c0.mp3";